import treasuryKidsApi from '../../api/treasury-kids-api';

const TREASURY_KIDS_SET_TECHNICAL_ERROR = 'TREASURY_KIDS_SET_TECHNICAL_ERROR';
const TREASURY_KIDS_SET_DISPLAY_NAMES = 'TREASURY_KIDS_SET_DISPLAY_NAMES';
const TREASURY_KIDS_SET_DISPLAY_NAME = 'TREASURY_KIDS_SET_DISPLAY_NAME';
const TREASURY_KIDS_SET_DATE = 'TREASURY_KIDS_SET_DATE';
const TREASURY_KIDS_SET_FILES = 'TREASURY_KIDS_SET_FILES';

export default {
	namespaced: true,
	state: {
		technicalError: false,
		files: [],
		displayNames: [],
		date: '',
		displayName: null
	},
	actions: {
		async getFiles({ commit }, { lang, day }) {
			commit(TREASURY_KIDS_SET_TECHNICAL_ERROR, false);
			try {
				let response = await treasuryKidsApi.getFiles(lang, day);
				commit(TREASURY_KIDS_SET_FILES, response.data.files);
				commit(TREASURY_KIDS_SET_DISPLAY_NAMES, response.data.displayNames);
				commit(TREASURY_KIDS_SET_DATE, response.data.date);
			} catch (err) {
				commit(TREASURY_KIDS_SET_TECHNICAL_ERROR, true);
				Promise.reject(err);
			}
		},
		setDisplayName({ commit }, displayName) {
			commit(TREASURY_KIDS_SET_DISPLAY_NAME, displayName);
		}
	},
	getters: {
		filteredFiles(state) {
			return state.displayName ? state.files.filter((file) => file.displayName == state.displayName) : state.files;
		}
	},
	mutations: {
		[TREASURY_KIDS_SET_TECHNICAL_ERROR](state, technicalError) {
			state.technicalError = technicalError;
		},
		[TREASURY_KIDS_SET_FILES](state, files) {
			state.files = files;
		},
		[TREASURY_KIDS_SET_DISPLAY_NAMES](state, displayNames) {
			state.displayNames = displayNames;
		},
		[TREASURY_KIDS_SET_DISPLAY_NAME](state, displayName) {
			state.displayName = displayName;
		},
		[TREASURY_KIDS_SET_DATE](state, date) {
			state.date = date;
		}
	}
};
